// SAJAFO — rechtermuisknop (contextmenu) uitgeschakeld op de hele site, zonder
// melding aan de bezoeker. Dit voorkomt onder meer dat iemand via "Afbeelding
// openen in nieuw tabblad" bij het logo direct het originele bronbestand opent.
(function () {
  document.addEventListener('contextmenu', function (event) {
    event.preventDefault();
  });
})();
